module.exports = __webpack_public_path__ + "img/icon_class.b8388177.svg";